
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class MatrixFundDetailsService {

  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  GetMatrixFindByStateID(TokenKey: string, UserID: string, StateId: any, ProductId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/MatrixFundDetails/GetMatrixFindByStateID/' + UserID + '/' + StateId + '/' + ProductId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetMatrixFundState(TokenKey: any, userId: number, productId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/MatrixFundDetails/GetMatrixFundFindByStateID/' + userId + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }


  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetIPCSMatrixFindByStateID(TokenKey: string, UserID: string, StateId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/MatrixFundDetails/GetIPCSMatrixFindByStateID/' + UserID + '/' + StateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
